import {
  BEST_ORDER_LABELS,
  DEFAULT_ORDER_LABELS,
  type ShippingOrderLabel,
  type ShippingOrderLabelOption,
} from '@/constants/shippingCarriers';

/**
 * Bộ nhãn hợp lệ của một hãng. Chưa chọn hãng ⇒ rỗng: nhãn chỉ có nghĩa trong
 * ngữ cảnh một hãng cụ thể, cho chọn trước là mời thu ngân chọn thứ sẽ bị xoá.
 */
export function orderLabelOptions(carrier?: string): ShippingOrderLabelOption[] {
  if (!carrier) return [];
  return carrier === 'best' ? BEST_ORDER_LABELS : DEFAULT_ORDER_LABELS;
}

/**
 * Nhãn còn dùng được với hãng đang chọn không. Không thì trả `undefined` để nơi
 * gọi XOÁ hẳn — giữ lại một nhãn hãng mới không hiểu là gửi rác cho hãng.
 */
export function normalizeOrderLabel(
  label: ShippingOrderLabel | undefined,
  carrier: string | undefined,
): ShippingOrderLabel | undefined {
  if (!label) return undefined;
  return orderLabelOptions(carrier).some((o) => o.value === label) ? label : undefined;
}
